import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../config.json";
import CustomLoader from "../Reusable/CustomLoader";

const Legal = () => {
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTerms = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/terms_condition/`);
        setTerms(response.data.data || []);
      } catch (error) {
        console.error("Error fetching terms and conditions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  return (
    <section className="section-p">
      <div className="page-width">
        <h1 className="legal-title text-jost-sb-50-wt">Legal</h1>
        <div className="legal__box">
          {loading ? (
            <CustomLoader type="spinner-cub" color="#B4C227" size={100} />
          ) : (
            terms.map((term) => (
              <div key={term.id}>
                <h2 className="legal__box-heading text-jost-sb-22-lg">
                  {term.title}
                </h2>
                <div
                  className="legal__box-para text-ops-rg-16"
                  dangerouslySetInnerHTML={{ __html: term.description }}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default Legal;
